export default __webpack_public_path__ + "static/media/trash.b61ed0cd.svg";